import { makeCrud, makeCrudHooks } from '../../lib/crud';

export const placesCrud = makeCrud('/places');
export const placesHooks = makeCrudHooks('places', placesCrud);

export const placesConfig = {
  key: 'places', title: 'Places', singular: 'Place', hooks: placesHooks,
  detailPath: (row) => `/places/${row.id}`,
  columns: [
    { key: 'name', header: 'Name' },
    { key: 'category', header: 'Category' },
    { key: 'rating', header: 'Rating' },
    { key: 'isPopular', header: 'Popular', render: (r) => (r.isPopular ? 'Yes' : 'No') },
  ],
  fields: [
    { name: 'name', label: 'Name', required: true },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'stateId', label: 'State ID' },
    { name: 'category', label: 'Category' },
    { name: 'imageUrl', label: 'Image URL' },
    { name: 'latitude', label: 'Latitude', type: 'number' },
    { name: 'longitude', label: 'Longitude', type: 'number' },
    { name: 'rating', label: 'Rating', type: 'number' },
    { name: 'isPopular', label: 'Popular', type: 'checkbox' },
    { name: 'tags', label: 'Tags (comma separated)', help: 'e.g. beach, family' },
  ],
};
